export default __webpack_public_path__ + "static/media/hand.f059d293.svg";